<template>
  <input ref="inputRef" type="text"/>
</template>

<script>
import { useCurrencyInput } from "vue-currency-input"

export default {
  name: "MoneyInput",

  props: {
    modelValue: Number,
    options: Object,
  },

  setup(props) {
    const { inputRef } = useCurrencyInput({
      currency: 'RUB',
      precision: 0,
      hideCurrencySymbolOnFocus: false,
      hideGroupingSeparatorOnFocus: false,
      hideNegligibleDecimalDigitsOnFocus: false,
      exportValueAsInteger: true,
    })

    return { inputRef }
  }
}
</script>

<style scoped>

</style>
